import { render, staticRenderFns } from "./FeatureCard.vue?vue&type=template&id=9ad6c186&scoped=true"
import script from "./FeatureCard.vue?vue&type=script&lang=ts"
export * from "./FeatureCard.vue?vue&type=script&lang=ts"
import style0 from "./FeatureCard.vue?vue&type=style&index=0&id=9ad6c186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad6c186",
  null
  
)

export default component.exports